import React from "react";

export default function AboutUs() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <div className="max-w-6xl mx-auto px-4 py-6 flex-grow">
        {/* Breadcrumb */}
        <div className="text-sm text-gray-500 mb-10">
          Home <span className="mx-2">/</span>
          Our Policies <span className="mx-2">/</span>
          <span className="text-black">About Us</span>
        </div>

        {/* Title */}
        <div className="mb-6">
          <h1 className="text-2xl font-semibold text-left">About Us</h1>
          <div className="w-full h-[1px] bg-gray-300 mt-2"></div>
        </div>

        {/* Content */}
        <div className="space-y-8 text-sm leading-7 text-gray-800">

          <section>
            <h2 className="text-amber-600 text-lg font-semibold mb-2">
              Who We Are
            </h2>
            <p>
              <strong>Happenhood</strong> is a modern event discovery and booking platform designed to connect people with experiences that matter. From concerts and workshops to local meetups, we bring everything together in one place.
            </p>
          </section>

          <section>
            <h2 className="text-amber-600 text-lg font-semibold mb-2">
              Our Mission
            </h2>
            <p>
              Our mission is to simplify how people discover, book, and manage events by offering a seamless, secure, and user-friendly platform.
            </p>
          </section>

          <section>
            <h2 className="text-amber-600 text-lg font-semibold mb-2">
              What We Offer
            </h2>
            <p>
              We provide a complete solution for both users and event organizers, including easy event discovery, smooth ticket booking, and powerful tools to manage events efficiently.
            </p>
          </section>

          <section>
            <h2 className="text-amber-600 text-lg font-semibold mb-2">
              Why Choose Us
            </h2>
            <p>
              With features like social login, real-time booking, and an intuitive interface, Happenhood ensures a hassle-free experience for users while empowering organizers to reach a wider audience.
            </p>
          </section>

          <section>
            <h2 className="text-amber-600 text-lg font-semibold mb-2">
              Our Vision
            </h2>
            <p>
              We aim to become a leading platform that connects communities through events and shared experiences, making every moment count.
            </p>
          </section>

          <section>
            <h2 className="text-amber-600 text-lg font-semibold mb-2">
              Contact Us
            </h2>
            <p>
              Have questions or need support? Reach out to us at:
            </p>
            <p className="text-blue-500">admin@happenhood.com</p>
            <p>📍 Happenhood, Noida, India</p>
          </section>

        </div>
      </div>
    </div>
  );
}
